/* import __COLOCATED_TEMPLATE__ from './reference-id.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class RequestChannelFieldsReferenceId extends Component {}
